<template>
  <q-icon :size="size" class="add">
    <svg width="13" viewBox="0 0 32 32" height="13" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <polygon points="29,15 17,15 17,3 15,3 15,15 3,15 3,17 15,17 15,29 17,29 17,17 29,17 " />
    </svg>
  </q-icon>
</template>

<script>

export default {
  name: 'AddIcon',
  props: {
    size: {
      type: String,
      default: '16px'
    }
  }
}
</script>

<style scoped>

</style>
